module.exports = "/_next/static/images/304ef50e788e7c6c3ebf7e88b8d08db4-lock.svg.webp";